import {
  watchLoadSitesOnTestCount,
  watchLoadSitesOnTest,
  watchLoadSitesOnTestCountLiveRefresh,
  watchLoadSitesOnTestLiveRefresh,
} from "./sitesOnTest";

import { all } from "redux-saga/effects";

export function* rootSaga() {
  yield all(
    [
      watchLoadSitesOnTestCount(),
      watchLoadSitesOnTest(),
      watchLoadSitesOnTestCountLiveRefresh(),
      watchLoadSitesOnTestLiveRefresh(),
    ],
  );
}